export const chatStarters = [
  {
    text: "How do I integrate Salesforce with my email system?",
  },
  {
    text: "Can you guide me through a marketing automation workflow?",
  },
  {
    text: "What's the best way to troubleshoot landing page errors?",
  },
  {
    text: "How do I set up a campaign in Marketo?",
  },
];
